// extracted by mini-css-extract-plugin
module.exports = {"maxWidthWrapper":"styles__maxWidthWrapper__38-Jp"};